import { getStoredCart } from "../utilities/handelLocalDB";

export const productList = {
    xHj88UQflCOXWd4QI6WT: {
        category: "Men's Sneaker",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto,fl_lossy,c_fill,g_auto/809d5f06a7c74e93aef3ad08017c415a_9366/adidas_Camo_Box_Graphic_Tee_Grey_HB4828_21_model.jpg",
        name: "ADIDAS CAMO BOX GRAPHIC TEE",
        price: 16,
        quantity: 0,
        ratings: 3,
        ratingsCount: 4505,
        seller: "Addidas",
        shipping: 11,
        stock: 10,
    },
    tsvDcCg132JOH2hHQU95: {
        category: "Men's Sneaker",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto,fl_lossy,c_fill,g_auto/fbaf991a78bc4896a3e9ad7800abcec6_9366/Ultraboost_22_Shoes_Black_GZ0127_01_standard.jpg",
        name: "ULTRABOOST 22 SHOES",
        price: 420,
        quantity: 0,
        ratings: 4.5,
        ratingsCount: 3725,
        seller: "Addidas",
        shipping: 1,
        stock: 20,
    },
    thktGCqhsnVQeQkNEA6M: {
        category: "Men's Sneaker",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto,fl_lossy,c_fill,g_auto/c6a321b7bb7243d28fe9ac71011393c7_9366/Own_the_Run_Long_Sleeve_Tee_Black_GJ9977_21_model.jpg",
        name: "OWN THE RUN LONG SLEEVE TEE",
        price: 23,
        quantity: 0,
        ratings: 3,
        ratingsCount: 4003,
        seller: "Addidas",
        shipping: 2,
        stock: 17,
    },
    r9m9b93PWIEUqgnoaEao: {
        category: "Men's Sneaker",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto,fl_lossy,c_fill,g_auto/96a5f085fedf4e678095abad01056711_9366/Lite_Racer_Adapt_3.0_Shoes_Black_FX8802_01_standard.jpg",
        name: "LITE RACER ADAPT 3.0 SHOES",
        price: 229,
        quantity: 0,
        ratings: 5,
        ratingsCount: 1764,
        seller: "Addidas",
        shipping: 32,
        stock: 10,
    },
    hEa2qrxA9Sw7F25RtZEE: {
        category: "Men's Sneaker",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto,fl_lossy,c_fill,g_auto/0e03e7a2a9cb44dfac2bad6a00f95888_9366/NMD_R1_Primeblue_Shoes_White_GZ9261_01_standard.jpg",
        name: "NMD_R1 PRIMEBLUE SHOES",
        price: 437,
        quantity: 0,
        ratings: 4,
        ratingsCount: 565,
        seller: "Addidas",
        shipping: 36,
        stock: 1,
    },
    dp65VVPMnz2dmNLPSwKT: {
        category: "Men's Sneaker",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto,fl_lossy,c_fill,g_auto/9889d39ac10243a2bb0fad1a0097ef07_9366/Essentials_Colorblock_Tee_Black_H14627_21_model.jpg",
        name: "ESSENTIALS COLORBLOCK TEE",
        price: 35,
        quantity: 0,
        ratings: 3.5,
        ratingsCount: 2680,
        seller: "Addidas",
        shipping: 39,
        stock: 6,
    },
    anKQgsCTPvRh0wyxo8YJ: {
        category: "Men's Sneaker",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto,fl_lossy,c_fill,g_auto/8c3f5445517340e8bc02ad8100ffd3f6_9366/Runner_Tee_Burgundy_H25050_21_model.jpg",
        name: "RUNNER TEE",
        price: 20,
        quantity: 0,
        ratings: 5,
        ratingsCount: 3343,
        seller: "Addidas",
        shipping: 48,
        stock: 7,
    },
    WNAOjYJppcZH4oWFruvO: {
        category: "Men's Sneaker",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto,fl_lossy,c_fill,g_auto/9a8256bb7ca34da49ff8ad5600bb2812_9366/4DFWD_Pulse_Shoes_White_Q46221_01_standard.jpg",
        name: "4DFWD PULSE SHOES",
        price: 226,
        quantity: 0,
        ratings: 4,
        ratingsCount: 2870,
        seller: "Addidas",
        shipping: 15,
        stock: 1,
    },
    W99ea6TNJ1kppzdBjQGB: {
        category: "Men's Sneaker",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto,fl_lossy,c_fill,g_auto/8c5d1994dfd343e28567ad4400dd351d_9366/4DFWD_Shoes_Black_Q46447_01_standard.jpg",
        name: "4DFWD SHOES",
        price: 287,
        quantity: 0,
        ratings: 4,
        ratingsCount: 799,
        seller: "Addidas",
        shipping: 49,
        stock: 11,
    },
    Ln7AYACCSMjpq8agELZr: {
        category: "Men's Sneaker",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto,fl_lossy,c_fill,g_auto/0af79283953e498480c6ac22015ec878_9366/Creator_365_Tee_Black_GL0465_21_model.jpg",
        name: "CREATOR 365 TEE",
        price: 34,
        quantity: 0,
        ratings: 3,
        ratingsCount: 4727,
        seller: "Addidas",
        shipping: 2,
        stock: 20,
    },
    KY8k6BnrebFE4uBItHne: {
        category: "Men's Sneaker",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto,fl_lossy,c_fill,g_auto/0e540bae86d5456aa034ada300ebf46c_9366/ZX_1K_Boost_Shoes_Grey_H00430_01_standard.jpg",
        name: "ZX 1K BOOST SHOES",
        price: 319,
        quantity: 0,
        ratings: 4,
        ratingsCount: 1360,
        seller: "Addidas",
        shipping: 50,
        stock: 7,
    },
    GLPzhb030iyIsg77mUlk: {
        category: "Men's Sneaker",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto,fl_lossy,c_fill,g_auto/c53945c38b614702ba6fae1d0164b2f1_9366/LNY_Trefoil_Fill_Tee_Black_HR9040_21_model.jpg",
        name: "LNY TREFOIL FILL TEE",
        price: 16,
        quantity: 0,
        ratings: 4,
        ratingsCount: 4985,
        seller: "Addidas",
        shipping: 35,
        stock: 17,
    },
    FZDesuLF7mPyHO1xGQXQ: {
        category: "Men's Sneaker",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto,fl_lossy,c_fill,g_auto/de7b5dc9e5a341b9bf5aad570106ba06_9366/Adicolor_Classics_Trefoil_Tee_Burgundy_H06641_21_model.jpg",
        name: "ADICOLOR CLASSICS TREFOIL TEE",
        price: 20,
        quantity: 0,
        ratings: 4.5,
        ratingsCount: 41,
        seller: "Addidas",
        shipping: 38,
        stock: 12,
    },
    Cwp1dY4yTBUVYxWPbNwp: {
        category: "Men's Sneaker",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto,fl_lossy,c_fill,g_auto/0846e90b15144861b33dacf500e3cfd1_9366/Kaptir_2.0_Shoes_White_H00276_01_standard.jpg",
        name: "KAPTIR 2.0 SHOES",
        price: 138,
        quantity: 0,
        ratings: 3.5,
        ratingsCount: 4372,
        seller: "Addidas",
        shipping: 19,
        stock: 19,
    },
    COj79jtbb9jFLkecDcPA: {
        category: "Men's Sneaker",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto,fl_lossy,c_fill,g_auto/c2a18c4e3f104d52a697ad6a01477bb7_9366/NMD_R1_V2_Shoes_Black_GX6367_01_standard.jpg",
        name: "NMD_R1 V2 SHOES",
        price: 260,
        quantity: 0,
        ratings: 5,
        ratingsCount: 1976,
        seller: "Addidas",
        shipping: 46,
        stock: 4,
    },
    BfSl4kSTqEDPIWh5lwi8: {
        category: "Men's Sneaker",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto,fl_lossy,c_fill,g_auto/abfc348baf3243289c4bada000d1238b_9366/V-Day_Tee_(Gender_Neutral)_Pink_HI6014_21_model.jpg",
        name: "V-DAY TEE (GENDER NEUTRAL)",
        price: 18,
        quantity: 0,
        ratings: 4,
        ratingsCount: 1590,
        seller: "Addidas",
        shipping: 13,
        stock: 2,
    },
    "6JmwFxzE3gPZbFxCYkFh": {
        category: "Men's Sneaker",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto,fl_lossy,c_fill,g_auto/ec81fbd781fe4aa3a8cead230019c192_9366/AEROREADY_Designed_2_Move_Feelready_Sport_Tee_Burgundy_H30268_21_model.jpg",
        name: "MOVE FEELREADY SPORT TEE",
        price: 14,
        quantity: 0,
        ratings: 3,
        ratingsCount: 4041,
        seller: "Addidas",
        shipping: 5,
        stock: 19,
    },
    "1s94oG2crbc2u5Vuzf6f": {
        category: "Men's Sneaker",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto,fl_lossy,c_fill,g_auto/e0101e13ac1940208478add1000e953a_9366/NYC_Badge_of_Sport_Logo_Graphic_Tee_White_HE2363_21_model.jpg",
        name: "NYC BADGE OF SPORT LOGO GRAPHIC TEE",
        price: 29,
        quantity: 0,
        ratings: 3,
        ratingsCount: 805,
        seller: "Addidas",
        shipping: 6,
        stock: 6,
    },
    "1r1uB1MAmEjXMmd2qlVp": {
        category: "Men's Sneaker",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto,fl_lossy,c_fill,g_auto/69cbc73d0cb846889f89acbb011e68cb_9366/Supernova_Shoes_Black_S42722_01_standard.jpg",
        name: "SUPERNOVA SHOES",
        price: 245,
        quantity: 0,
        ratings: 4,
        ratingsCount: 3972,
        seller: "Addidas",
        shipping: 1,
        stock: 20,
    },
    "1cxSxqGg5NoiZomwuioL": {
        category: "Men's Sneaker",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto,fl_lossy,c_fill,g_auto/2cee64414e1f4f31baf1ae270099d950_9366/Lunar_New_Year_Ultraboost_DNA_Shoes_Black_GZ6074_01_standard.jpg",
        name: "LUNAR NEW YEAR ULTRABOOST DNA SHOES",
        price: 196,
        quantity: 0,
        ratings: 5,
        ratingsCount: 4355,
        seller: "Addidas",
        shipping: 14,
        stock: 19,
    },
    wFanhPZjHZubaJlnYVjT: {
        category: "Men's Pants",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto,fl_lossy,c_fill,g_auto/c7f050932336444ca286acbb0121f995_9366/Essentials_French_Terry_Tapered-Cuff_3-Stripes_Pants_Grey_GK8824_21_model.jpg",
        name: "TAPERED-CUFF 3-STRIPES PANTS",
        price: 108,
        quantity: 0,
        ratings: 3,
        ratingsCount: 3383,
        seller: "Addidas",
        shipping: 26,
        stock: 5,
    },
    hgJOG5wjePzGTwFJxJbl: {
        category: "Men's Pants",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto,fl_lossy,c_fill,g_auto/3cb8057730844247a568ac9800fa36fb_9366/Tiro_21_Track_Pants_Blue_GE5425_21_model.jpg",
        name: "TIRO 21 TRACK PANTS",
        price: 148,
        quantity: 0,
        ratings: 3,
        ratingsCount: 4483,
        seller: "Addidas",
        shipping: 8,
        stock: 41,
    },
    faIC8v4HRQ8IweV43TW9: {
        category: "Men's Pants",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto,fl_lossy,c_fill,g_auto/3fb5325716cc4e45a76bac4700ea31dc_9366/Essentials_French_Terry_Tapered_Cuff_Logo_Pants_Black_GK8968_21_model.jpg",
        name: "FRENCH TERRY TAPERED CUFF LOGO PANTS",
        price: 189,
        quantity: 0,
        ratings: 3.5,
        ratingsCount: 1974,
        seller: "Addidas",
        shipping: 20,
        stock: 27,
    },
    dHtmQv97UUIkCI8a02La: {
        category: "Men's Pants",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto,fl_lossy,c_fill,g_auto/c98bbccc77934722b139acb80111a3d7_9366/Tiro_Track_Pants_Red_GT6841_21_model.jpg",
        name: "TIRO TRACK PANTS RED",
        price: 122,
        quantity: 0,
        ratings: 4,
        ratingsCount: 1239,
        seller: "Addidas",
        shipping: 27,
        stock: 43,
    },
    X8arFSPQe5adtquUEsqL: {
        category: "Men's Pants",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto,fl_lossy,c_fill,g_auto/856e874762eb48da8e22acda00efaeb4_9366/Tiro_Track_Pants_Black_GN5490_21_model.jpg",
        name: "TIRO TRACK PANTS",
        price: 146,
        quantity: 0,
        ratings: 5,
        ratingsCount: 3702,
        seller: "Addidas",
        shipping: 29,
        stock: 15,
    },
    HUEmoHA14t7oXy9ESPPE: {
        category: "Men's Pants",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto,fl_lossy,c_fill,g_auto/d47f8bc94b2c401b9eafad23007fd8c4_9366/Primegreen_Essentials_Warm-Up_Open_Hem_3-Stripes_Track_Pants_Black_H48430_21_model.jpg",
        name: "OPEN HEM 3-STRIPES TRACK PANTS",
        price: 58,
        quantity: 0,
        ratings: 5,
        ratingsCount: 2140,
        seller: "Addidas",
        shipping: 49,
        stock: 41,
    },
    HOJHsYihSZfgstj1ZEof: {
        category: "Men's Pants",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto,fl_lossy,c_fill,g_auto/9c7058d8677742ac8519ac3f009cdcf4_9366/Tiro_21_Track_Pants_Black_GH7305_21_model.jpg",
        name: "TIRO 21 TRACK PANTS",
        price: 109,
        quantity: 0,
        ratings: 5,
        ratingsCount: 1688,
        seller: "Addidas",
        shipping: 48,
        stock: 6,
    },
    GCwGWJ36ZAqjJF5z6iPH: {
        category: "Men's Pants",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto,fl_lossy,c_fill,g_auto/c447324cf06544b78105ade500fd9e2f_9366/Tiro_Pants_Black_HI1073_21_model.jpg",
        name: "TIRO PANTS BLACK GOLD",
        price: 115,
        quantity: 0,
        ratings: 5,
        ratingsCount: 4557,
        seller: "Addidas",
        shipping: 33,
        stock: 26,
    },
    "9PkWz2SGjMiTHWigZaxa": {
        category: "Men's Pants",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto,fl_lossy,c_fill,g_auto/52b5fde5829a4a04820dacf50127b969_9366/Adicolor_Classics_Primeblue_SST_Track_Pants_Blue_H06714_21_model.jpg",
        name: "PRIMEBLUE SST TRACK PANTS",
        price: 63,
        quantity: 0,
        ratings: 4,
        ratingsCount: 50,
        seller: "Addidas",
        shipping: 20,
        stock: 46,
    },
    "1hQOc6rrKPCCrHCrjTts": {
        category: "Men's Pants",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto,fl_lossy,c_fill,g_auto/64f1ba254925439d88eaad920127d77e_9366/Essentials4Gameday_Pants_Black_HE1800_21_model.jpg",
        name: "ESSENTIALS4GAMEDAY PANTS",
        price: 185,
        quantity: 0,
        ratings: 5,
        ratingsCount: 2676,
        seller: "Addidas",
        shipping: 27,
        stock: 43,
    },
    zsDl05YI90vB7ueebZ2u: {
        category: "Men's Boot",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto,fl_lossy,c_fill,g_auto/12cf12ac1c8e484ea487ad6400ee3444_9366/Terrex_Free_Hiker_Gore-Tex_Hiking_Shoes_Black_GZ0355_01_standard.jpg",
        name: "TERREX FREE HIKER GORE-TEX HIKING SHOES",
        price: 132,
        quantity: 0,
        ratings: 3,
        ratingsCount: 128,
        seller: "Addidas",
        shipping: 13,
        stock: 1,
    },
    lbuaRWA4yecA0tfOJVu9: {
        category: "Men's Boot",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto,fl_lossy,c_fill,g_auto/c2ee4c27eba64258bcbaad5100e5d998_9366/Terrex_Trailmaker_Mid_COLD.RDY_Hiking_Shoes_Brown_FZ3370_01_standard.jpg",
        name: "TERREX TRAILMAKER MID COLD.RDY HIKING SHOES",
        price: 110,
        quantity: 0,
        ratings: 3,
        ratingsCount: 1533,
        seller: "Addidas",
        shipping: 33,
        stock: 16,
    },
    jNGy7mXiCnjrB2REuiGj: {
        category: "Men's Boot",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto,fl_lossy,c_fill,g_auto/dfa8c9a7d2864065b27fad7400b2e05e_9366/Terrex_AX4_Mid_GORE-TEX_Hiking_shoes_Black_FY9638_01_standard.jpg",
        name: "TERREX AX4 MID GORE-TEX HIKING SHOES",
        price: 111,
        quantity: 0,
        ratings: 4.5,
        ratingsCount: 894,
        seller: "Addidas",
        shipping: 27,
        stock: 19,
    },
    h60rMtsgF8uXEvjqFuTo: {
        category: "Men's Boot",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto,fl_lossy,c_fill,g_auto/3a819de9f29c498fae13ab6d01473c4d_9366/Tactical_Lexicon_ADV_Boots_White_EG9385_01_standard.jpg",
        name: "TACTICAL LEXICON ADV BOOTS",
        price: 199,
        quantity: 0,
        ratings: 4,
        ratingsCount: 2422,
        seller: "Addidas",
        shipping: 39,
        stock: 14,
    },
    ecHuBKf80RHHWYO4vFqV: {
        category: "Men's Boot",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto,fl_lossy,c_fill,g_auto/f5350f3d583c46038534ab6d01445e2a_9366/Tactical_Lexicon_ADV_Boots_Grey_EG9386_01_standard.jpg",
        name: "TACTICAL LEXICON ADV BOOTS",
        price: 151,
        quantity: 0,
        ratings: 4,
        ratingsCount: 584,
        seller: "Addidas",
        shipping: 33,
        stock: 3,
    },
    Z5yE1R9Pp2veMAei0IO3: {
        category: "Men's Boot",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto,fl_lossy,c_fill,g_auto/2ded0bee28b249bbb19cad5000818b77_9366/Terrex_Free_Hiker_COLD.RDY_Hiking_Boots_Black_FZ3364_01_standard.jpg",
        name: "TERREX FREE HIKER COLD.RDY HIKING BOOTS",
        price: 169,
        quantity: 0,
        ratings: 5,
        ratingsCount: 2833,
        seller: "Addidas",
        shipping: 10,
        stock: 17,
    },
    OtasmJMzfUiXXzv8Boyz: {
        category: "Men's Boot",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto,fl_lossy,c_fill,g_auto/efbedb26b92e4affa103ad6b008a789a_9366/Terrex_Free_Hiker_Gore-Tex_Hiking_Shoes_Grey_GZ0356_01_standard.jpg",
        name: "TERREX FREE HIKER GORE-TEX HIKING SHOES",
        price: 155,
        quantity: 0,
        ratings: 5,
        ratingsCount: 1351,
        seller: "Addidas",
        shipping: 38,
        stock: 4,
    },
    OoqdRCrZadoPTk2PZXaF: {
        category: "Men's Boot",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto,fl_lossy,c_fill,g_auto/0a340319370844e99645abc90091df96_9366/Terrex_Agravic_Tech_Pro_Trail_Running_Shoes_Black_FU7634_01_standard.jpg",
        name: "TERREX AGRAVIC TECH PRO TRAIL RUNNING SHOES",
        price: 118,
        quantity: 0,
        ratings: 3,
        ratingsCount: 1798,
        seller: "Addidas",
        shipping: 37,
        stock: 8,
    },
    F5zYYt3Po9JC9xxd9To5: {
        category: "Men's Boot",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto:sensitive,fl_lossy,c_fill,g_auto/6853ac5565a9407bae19ac080120d9d7_9366/Superstar_Boots_Red_FZ2642_01_standard.jpg",
        name: "Superstar Boots",
        price: 151,
        quantity: 0,
        ratings: 3,
        ratingsCount: 1010,
        seller: "Addidas",
        shipping: 4,
        stock: 13,
    },
    "2wFIGTR188uVyfakM9fB": {
        category: "Men's Boot",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto,fl_lossy,c_fill,g_auto/b513f2cec8b440978d60ab6d014ad452_9366/Response_3MC_ADV_Boots_Black_EG9391_01_standard.jpg",
        name: "RESPONSE 3MC ADV BOOTS",
        price: 104,
        quantity: 0,
        ratings: 5,
        ratingsCount: 354,
        seller: "Addidas",
        shipping: 26,
        stock: 6,
    },
    xhSx2LQoArny0uVa3oZo: {
        category: "Earphones",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto:sensitive,fl_lossy,c_fill,g_auto/00276c6c380b41bcb29fadcc00f98312_9366/adidas_Z.N.E._01_True_Wireless_Earbuds_Grey_EY5116_42_detail.jpg",
        name: "adidas Z.N.E. 01 True Wireless Earbuds",
        price: 142,
        quantity: 0,
        ratings: 5,
        ratingsCount: 22,
        seller: "Addidas",
        shipping: 23,
        stock: 11,
    },
    WZPCeCRk8bwDyjGaypWW: {
        category: "Earphones",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto:sensitive,fl_lossy,c_fill,g_auto/523731a02e914d318cb4adcc00f985ba_9366/adidas_FWD-02_Sport_True_Wireless_Earbuds_Grey_EY5113_03_standard_hover.jpg",
        name: "adidas FWD-02 Sport True Wireless Earbuds",
        price: 162,
        quantity: 0,
        ratings: 4,
        ratingsCount: 6,
        seller: "Addidas",
        shipping: 29,
        stock: 14,
    },
    SWcwPAupWhCaT8dBwZmP: {
        category: "Earphones",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto:sensitive,fl_lossy,c_fill,g_auto/b322cdef8e654551ace9adcc00f963ed_9366/adidas_Z.N.E._01_ANC_True_Wireless_Earbuds_Grey_EY5114_41_detail.jpg",
        name: "adidas Z.N.E. 01 ANC True Wireless Earbuds",
        price: 135,
        quantity: 0,
        ratings: 5,
        ratingsCount: 51,
        seller: "Addidas",
        shipping: 30,
        stock: 16,
    },
    "9liGOXUt4M5vLPNwp25s": {
        category: "Earphones",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto:sensitive,fl_lossy,c_fill,g_auto/2cdb8652aa2340369ba2aa79010062d1_9366/FWD-01_Sport_In-Ear_Headphones_Black_CM5016_01_standard.jpg",
        name: "FWD-01 Sport In-Ear Headphones",
        price: 185,
        quantity: 0,
        ratings: 4,
        ratingsCount: 66,
        seller: "Addidas",
        shipping: 15,
        stock: 8,
    },
    "4buSGB7Ut4Pux3RK9VEu": {
        category: "Earphones",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto:sensitive,fl_lossy,c_fill,g_auto/9e6e7967b3b24ef298f5adcc00f983ec_9366/adidas_Z.N.E._01_ANC_True_Wireless_Earbuds_Grey_EY5115_41_detail.jpg",
        name: "adidas Z.N.E. 01 ANC True Wireless Earbuds",
        price: 110,
        quantity: 0,
        ratings: 5,
        ratingsCount: 9,
        seller: "Addidas",
        shipping: 48,
        stock: 15,
    },
    "0e9cBGc9WZ1e5BbeMKfi": {
        category: "Earphones",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto:sensitive,fl_lossy,c_fill,g_auto/c697ceddb0c2469aaa2eaa7101121d10_9366/RPT-01_Sport_On-Ear_Headphones_Black_CM5015_01_standard.jpg",
        name: "RPT-01 Sport On-Ear Headphones",
        price: 170,
        quantity: 0,
        ratings: 5,
        ratingsCount: 55,
        seller: "Addidas",
        shipping: 48,
        stock: 15,
    },
    wtn1OMmfa1ZprqdzMgSJ: {
        category: "Cap",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto:sensitive,fl_lossy,c_fill,g_auto/0ae141db6fce44999337ac8e015954ea_9366/Superlite_Hat_Grey_EX7054_01_standard.jpg",
        name: "Superlite Hat",
        price: 11,
        quantity: 0,
        ratings: 3,
        ratingsCount: 39,
        seller: "Addidas",
        shipping: 32,
        stock: 18,
    },
    sfhh9l2y0ubsPosVcJPm: {
        category: "Cap",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto:sensitive,fl_lossy,c_fill,g_auto/df67ab60b5574c368b76adf9010f2d2d_9366/Tee_Time_5-Panel_Hat_Black_HA9254_01_standard.jpg",
        name: "Tee Time 5-Panel Hat",
        price: 24,
        quantity: 0,
        ratings: 4,
        ratingsCount: 14,
        seller: "Addidas",
        shipping: 48,
        stock: 1,
    },
    l3pLt0vOYVPUR214vlCw: {
        category: "Cap",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto:sensitive,fl_lossy,c_fill,g_auto/4feb20f4d990407cb4f1a88a0040b212_9366/Relaxed_Strap-Back_Hat_Black_BH7137_01_standard.jpg",
        name: "Relaxed Strap-Back Hat",
        price: 30,
        quantity: 0,
        ratings: 4,
        ratingsCount: 4,
        seller: "Addidas",
        shipping: 1,
        stock: 6,
    },
    l0PejzhbxjxJvhr0P4IV: {
        category: "Cap",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto:sensitive,fl_lossy,c_fill,g_auto/92e77a8d84d845d19171ad50003f2ea1_9366/SST_Plus_Strap-Back_Hat_White_FZ8569_01_standard.jpg",
        name: "SST Plus Strap-Back Hat",
        price: 23,
        quantity: 0,
        ratings: 4,
        ratingsCount: 32,
        seller: "Addidas",
        shipping: 47,
        stock: 14,
    },
    cZSnoyiG1svhhxu5AV07: {
        category: "Cap",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto:sensitive,fl_lossy,c_fill,g_auto/c3981523051c4a978674ad3c01015664_9366/Dispatch_Trucker_Hat_Black_EY5534_01_standard.jpg",
        name: "Dispatch Trucker Hat",
        price: 28,
        quantity: 0,
        ratings: 4,
        ratingsCount: 30,
        seller: "Addidas",
        shipping: 14,
        stock: 16,
    },
    NcCjJPL3BIM9vqlpG68s: {
        category: "Cap",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto:sensitive,fl_lossy,c_fill,g_auto/e1e758585df14bbbb7d8aaf000c95bd7_9366/UNISEX_ORIGINALS_WASHED_BUCKET_White_CM3933_01_standard.jpg",
        name: "UNISEX ORIGINALS WASHED BUCKET",
        price: 27,
        quantity: 0,
        ratings: 4,
        ratingsCount: 3,
        seller: "Addidas",
        shipping: 14,
        stock: 14,
    },
    LldcWW6tApMUuraRFdc3: {
        category: "Cap",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto:sensitive,fl_lossy,c_fill,g_auto/272d5d9cb7b74415a6c9ac8e015a4ccc_9366/Superlite_Hat_Black_EX7048_01_standard.jpg",
        name: "Superlite Hat",
        price: 10,
        quantity: 0,
        ratings: 5,
        ratingsCount: 47,
        seller: "Addidas",
        shipping: 24,
        stock: 10,
    },
    Ka7rVJ4TJnuK3nVHjI5c: {
        category: "Cap",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto:sensitive,fl_lossy,c_fill,g_auto/aaa5ae549c624178bc25a740012dd61f_9366/Relaxed_Strap-Back_Hat_White_BH7135_01_standard.jpg",
        name: "Relaxed Strap-Back Hat",
        price: 24,
        quantity: 0,
        ratings: 5,
        ratingsCount: 15,
        seller: "Addidas",
        shipping: 6,
        stock: 9,
    },
    FaLUqabZf7pKHXctvLn4: {
        category: "Cap",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto:sensitive,fl_lossy,c_fill,g_auto/1e27ae8bbfb647489261ac8e015d181f_9366/Icon_Snapback_Hat_Grey_EX6798_01_standard.jpg",
        name: "Icon Snapback Hat",
        price: 21,
        quantity: 0,
        ratings: 4,
        ratingsCount: 1,
        seller: "Addidas",
        shipping: 26,
        stock: 13,
    },
    "9cHHIKPrqXbhjXb2gHIQ": {
        category: "Cap",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto:sensitive,fl_lossy,c_fill,g_auto/0ce5f49aa0914deabf16adc600d09e60_9366/Baseball_Cap_Black_HD7039_01_standard.jpg",
        name: "Baseball Cap",
        price: 17,
        quantity: 0,
        ratings: 5,
        ratingsCount: 37,
        seller: "Addidas",
        shipping: 48,
        stock: 7,
    },
    rFYL4EjR1tQGyj88zRYU: {
        category: "Bottle",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto:sensitive,fl_lossy,c_fill,g_auto/29ef510920b54492a721aa1c01782cb2_9366/Steel_Metal_Bottle_1L_White_CL6092_01_standard.jpg",
        name: "Steel Metal Bottle 1L",
        price: 20,
        quantity: 0,
        ratings: 5,
        ratingsCount: 63,
        seller: "Addidas",
        shipping: 21,
        stock: 14,
    },
    qbNSYEWMPuHf7TupV2zj: {
        category: "Bottle",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto:sensitive,fl_lossy,c_fill,g_auto/c670a94f6388451a868fad440014460d_9366/Steel_Metal_Bottle_1_L_Purple_EY5529_01_standard.jpg",
        name: "Steel Metal Bottle 1 L",
        price: 46,
        quantity: 0,
        ratings: 5,
        ratingsCount: 73,
        seller: "Addidas",
        shipping: 45,
        stock: 2,
    },
    orqSITkO4OUtvZ83Wpwi: {
        category: "Bottle",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto:sensitive,fl_lossy,c_fill,g_auto/f8d89293c9cb4bf08d52adb100f95a3a_9366/Steel_Metal_Bottle_2L_Black_EX7302_01_standard.jpg",
        name: "Steel Metal Bottle 2L",
        price: 37,
        quantity: 0,
        ratings: 4,
        ratingsCount: 68,
        seller: "Addidas",
        shipping: 27,
        stock: 14,
    },
    oj8Q0MfuRUA5SXxXRLBj: {
        category: "Bottle",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto:sensitive,fl_lossy,c_fill,g_auto/1105dc0c9232477eb80dac7d000edc0c_9366/Steel_Metal_Bottle_600_ML_White_EX7306_01_standard.jpg",
        name: "Steel Metal Bottle 600 ML",
        price: 43,
        quantity: 0,
        ratings: 4,
        ratingsCount: 64,
        seller: "Addidas",
        shipping: 43,
        stock: 19,
    },
    oVu3aNFUC2QemJbEvw4L: {
        category: "Bottle",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto:sensitive,fl_lossy,c_fill,g_auto/f7fb63986ed34112bc57ac7d002c9f43_9366/Steel_Straw_Metal_Bottle_600_ML_White_EX7316_01_standard.jpg",
        name: "Steel Straw Metal Bottle 600 ML",
        price: 43,
        quantity: 0,
        ratings: 3,
        ratingsCount: 15,
        seller: "Addidas",
        shipping: 46,
        stock: 10,
    },
    kN69W8klxxMzaWViVhHX: {
        category: "Bottle",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto:sensitive,fl_lossy,c_fill,g_auto/e2d870a680644e4d98e9ac7d0008ecc7_9366/Steel_Metal_Bottle_600_ML_Yellow_EX7307_01_standard.jpg",
        name: "Steel Metal Bottle 600 ML",
        price: 26,
        quantity: 0,
        ratings: 5,
        ratingsCount: 83,
        seller: "Addidas",
        shipping: 6,
        stock: 20,
    },
    OXs2bzHRknNz5sChzMQ5: {
        category: "Bottle",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto:sensitive,fl_lossy,c_fill,g_auto/a9c04ca9fa51408faf2fac8e0117abb9_9366/Steel_Metal_Bottle_1L_Black_EX7288_01_standard.jpg",
        name: "Steel Metal Bottle 1L",
        price: 33,
        quantity: 0,
        ratings: 4,
        ratingsCount: 62,
        seller: "Addidas",
        shipping: 15,
        stock: 7,
    },
    MaXe6Hg7SslcgdrSaOcY: {
        category: "Bottle",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto:sensitive,fl_lossy,c_fill,g_auto/48057b65216644f683a9aa1c0172ae6e_9366/Steel_Bottle_600_ML_Black_CL6093_01_standard.jpg",
        name: "Steel Bottle 600 ML",
        price: 23,
        quantity: 0,
        ratings: 5,
        ratingsCount: 35,
        seller: "Addidas",
        shipping: 5,
        stock: 11,
    },
    FEDSJo433jRC00xbksUK: {
        category: "Bottle",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto:sensitive,fl_lossy,c_fill,g_auto/77ad16764abf4e828560ad44001cd640_9366/Squad_Glass_Bottle_720_ML_Black_FZ7115_01_standard.jpg",
        name: "Squad Glass Bottle 720 ML",
        price: 39,
        quantity: 0,
        ratings: 3,
        ratingsCount: 1,
        seller: "Addidas",
        shipping: 5,
        stock: 20,
    },
    "5bNOxpeM4dmz4KAujlQt": {
        category: "Bottle",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto:sensitive,fl_lossy,c_fill,g_auto/c45df020e3ae4e9199a4ac7d0001cfb7_9366/Steel_Metal_Bottle_1L_White_EX7301_01_standard.jpg",
        name: "Steel Metal Bottle 1L",
        price: 40,
        quantity: 0,
        ratings: 5,
        ratingsCount: 58,
        seller: "Addidas",
        shipping: 17,
        stock: 14,
    },
    tRrAUhmcmAmnEz0KQ3tQ: {
        category: "Bag",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto:sensitive,fl_lossy,c_fill,g_auto/c2aaf5e8a7924f1d9277ac9f005b5f37_9366/Santiago_Lunch_Bag_Black_EX6532_01_standard.jpg",
        name: "Santiago Lunch Bag",
        price: 63,
        quantity: 0,
        ratings: 3,
        ratingsCount: 346,
        seller: "Addidas",
        shipping: 42,
        stock: 10,
    },
    sG8kzt0m2ceW4TEj8Zon: {
        category: "Bag",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto:sensitive,fl_lossy,c_fill,g_auto/ba79ccb861fd4fd49e3aac9f006a6407_9366/3-Stripes_Backpack_2.0_Grey_EX6735_01_standard.jpg",
        name: "3-Stripes Backpack 2.0",
        price: 74,
        quantity: 0,
        ratings: 5,
        ratingsCount: 365,
        seller: "Addidas",
        shipping: 23,
        stock: 7,
    },
    rdoj9FyHe3WfGhEkxXZ2: {
        category: "Bag",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto:sensitive,fl_lossy,c_fill,g_auto/dc7dca21df62473ea518ade101251809_9366/R.Y.V._Backpack_Black_HD9650_01_standard.jpg",
        name: "R.Y.V. Backpack",
        price: 67,
        quantity: 0,
        ratings: 5,
        ratingsCount: 83,
        seller: "Addidas",
        shipping: 24,
        stock: 10,
    },
    lyRrPV41WLBVBqSQM36n: {
        category: "Bag",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto:sensitive,fl_lossy,c_fill,g_auto/0bb325f9cc174ea4bed7ad9e0101b682_9366/Adicolor_Archive_Backpack_Green_HE9804_01_standard.jpg",
        name: "Adicolor Archive Backpack",
        price: 84,
        quantity: 0,
        ratings: 4,
        ratingsCount: 445,
        seller: "Addidas",
        shipping: 19,
        stock: 5,
    },
    jf7o58Elmqixcu1sW7E7: {
        category: "Bag",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto:sensitive,fl_lossy,c_fill,g_auto/a520df1b51384c00af9caca100489f04_9366/Trefoil_Backpack_Black_EX6752_01_standard.jpg",
        name: "Trefoil Backpack",
        price: 65,
        quantity: 0,
        ratings: 4,
        ratingsCount: 465,
        seller: "Addidas",
        shipping: 36,
        stock: 3,
    },
    gmMoohLK7RpRhxf4rtIJ: {
        category: "Bag",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto:sensitive,fl_lossy,c_fill,g_auto/1c87c940836e4628852bad130101e5c6_9366/R.Y.V._Toploader_Backpack_Black_H32458_01_standard.jpg",
        name: "R.Y.V. Toploader Backpack",
        price: 56,
        quantity: 0,
        ratings: 3,
        ratingsCount: 471,
        seller: "Addidas",
        shipping: 20,
        stock: 19,
    },
    TZqwgcxOjcq32rXILz9W: {
        category: "Bag",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto:sensitive,fl_lossy,c_fill,g_auto/a9e0c5635057425daab5ad0b0089194b_9366/Blue_Version_Backpack_Black_H22735_01_standard.jpg",
        name: "Blue Version Backpack",
        price: 87,
        quantity: 0,
        ratings: 5,
        ratingsCount: 234,
        seller: "Addidas",
        shipping: 21,
        stock: 15,
    },
    HWF74cF9oXOOlJcOBdLU: {
        category: "Bag",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto:sensitive,fl_lossy,c_fill,g_auto/ac09bb56249b43158485aca1007cc1ef_9366/Excel_Backpack_Black_EX6933_01_standard.jpg",
        name: "Excel Backpack",
        price: 62,
        quantity: 0,
        ratings: 5,
        ratingsCount: 168,
        seller: "Addidas",
        shipping: 14,
        stock: 18,
    },
    "8nXKZBxx72xySV4sX2IB": {
        category: "Bag",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto:sensitive,fl_lossy,c_fill,g_auto/2e8a6f09838d49c3b00fad4f0017f753_9366/Alliance_Sackpack_White_FZ6823_01_standard.jpg",
        name: "Alliance Sackpack",
        price: 99,
        quantity: 0,
        ratings: 3,
        ratingsCount: 311,
        seller: "Addidas",
        shipping: 40,
        stock: 16,
    },
    "6uaEjYWgiBNuRUFDLlYf": {
        category: "Bag",
        img: "https://assets.adidas.com/images/h_840,f_auto,q_auto:sensitive,fl_lossy,c_fill,g_auto/d6ee0177281f42f0a254acb1016aa051_9366/Defender_Backpack_Red_EX7011_01_standard.jpg",
        name: "Defender Backpack",
        price: 96,
        quantity: 0,
        ratings: 4,
        ratingsCount: 241,
        seller: "Addidas",
        shipping: 15,
        stock: 10,
    },
};

// Get Products By Stored Ids
export const getStoredProducts = async () => {
    const storedCart = getStoredCart();
    const ids = Object.keys(storedCart);

    const data = [];

    for (const id of ids) {
        const product = productList[id];
        if (product) {
            data.push({ _id: id, ...product });
        }
    }

    return { data, storedCart };
};
